export default __webpack_public_path__ + "static/media/input-down.bc2dc441.svg";